"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = exports.Content = exports.BodyContainer = exports.Container = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = require("prop-types");
const framer_motion_1 = require("framer-motion");
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
const breakpoints_1 = require("../../lib/constants/breakpoints");
exports.Container = (0, styled_1.default)('div') `
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
`;
exports.BodyContainer = (0, styled_1.default)('div') `
  padding: 0 ${(0, ui_theme_1.fromTheme)('spacing_large')} ${(0, ui_theme_1.fromTheme)('spacing_medium')}
    ${(0, ui_theme_1.fromTheme)('spacing_large')};
  position: relative;

  ${({ isApptSummary }) => isApptSummary &&
    `
      padding: 0;
    `}
  position: relative;
`;
const Content = (_a) => {
    var { showSidebar, children } = _a, rest = __rest(_a, ["showSidebar", "children"]);
    // NOTE: using `style` to avoid re-rendering the tree and losing local state
    const style = showSidebar
        ? {
            width: `calc(100% - ${breakpoints_1.SIDEBAR_WIDTH} - ${(0, ui_theme_1.fromTheme)('spacing_large')(rest)}`
        }
        : { width: '100%' };
    return react_1.default.createElement("div", { style: style }, children);
};
exports.Content = Content;
exports.Content.propTypes = {
    showSidebar: prop_types_1.bool.isRequired,
    children: prop_types_1.node.isRequired
};
exports.Body = (0, styled_1.default)(framer_motion_1.motion.div) `
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  position: relative;

  @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    margin-top: ${(0, ui_theme_1.fromTheme)('spacing_large')};
    flex-direction: row;
  }
`;
//# sourceMappingURL=styles.js.map